import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';
import { TenantPickerField } from '../fields/TenantPicker';
import {
  tenantPickerUiOptionsSchema,
  tenantPickerValueSchema,
} from '../schemas/tenantPickerSchema';

export const tenantPickerFieldExtension: any = FormFieldBlueprint.make({
  name: 'tenant-picker',
  params: {
    field: async () =>
      createFormField({
        name: 'TenantPicker',
        component: TenantPickerField,
        schema: makeFieldSchema({
          output: () => tenantPickerValueSchema,
          uiOptions: () => tenantPickerUiOptionsSchema,
        }),
      }),
  },
});
